// Storage utilities for handling remember me functionality

export const storageUtils = {
  // Set data with remember me logic
  setAuthData: (key, value, rememberMe = false) => {
    const storage = rememberMe ? localStorage : sessionStorage;
    storage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : value);
  },

  // Get data from both localStorage and sessionStorage
  getAuthData: (key) => {
    try {
      // First check localStorage, then sessionStorage
      let value = localStorage.getItem(key);
      if (value) {
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      }
      
      value = sessionStorage.getItem(key);
      if (value) {
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      }
      
      return null;
    } catch (error) {
      console.error('Error getting auth data:', error);
      return null;
    }
  },

  // Remove data from both storages
  removeAuthData: (key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  },

  // Clear all auth data
  clearAllAuthData: () => {
    // Remove from both storages
    const authKeys = ['accessToken', 'refreshToken', 'user'];
    authKeys.forEach(key => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
  }
};